/*
Cấu hình thời gian khách hàng ở trong tập, dùng chung cho màn Thêm và màn Sửa tập KH.
Đơn vị GIÂY, khớp với 2 cột audiences.min_stay_time / audiences.max_stay_time:

- Tối thiểu: khách vừa vào tập được giữ chỗ ít nhất bấy nhiêu giây, chưa đủ thì không
  bị kích ra dù không còn thỏa điều kiện lọc. Mặc định 0 = không giữ chỗ.
- Tối đa: khách không được ở trong tập quá bấy nhiêu giây. Để trống = vô hạn, đây cũng
  là mặc định.
*/
export const DEFAULT_MIN_STAY_TIME = 0;
// Trần của cột int unsigned trong DB (~136 năm)
export const STAY_TIME_MAX_SECONDS = 4294967295;

/*
Ô nhập antd InputNumber trả về number khi hợp lệ và null khi để trống, nhưng dữ liệu
từ API về có thể là chuỗi hoặc null. Quy hết về number | null để mọi chỗ so sánh và
gửi lên server đều làm việc trên cùng một kiểu.
*/
export function toStayTimeNumber(value) {
  if (value === null || value === undefined || String(value).trim() === '') {
    return null;
  }
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

/*
Kiểm tra cặp min/max trước khi gửi lên server. Trả về object lỗi theo từng ô (rỗng khi
hợp lệ) để gán thẳng vào state err của hai màn hình.
*/
export function getStayTimeErrors({ minStayTime, maxStayTime }) {
  const errors = {};
  const min = toStayTimeNumber(minStayTime);
  const max = toStayTimeNumber(maxStayTime);
  if (min !== null && (!Number.isInteger(min) || min < 0 || min > STAY_TIME_MAX_SECONDS)) {
    errors.minStayTime = `Thời gian tối thiểu phải là số nguyên từ 0 đến ${STAY_TIME_MAX_SECONDS} giây`;
  }
  if (max !== null && (!Number.isInteger(max) || max < 1 || max > STAY_TIME_MAX_SECONDS)) {
    errors.maxStayTime = `Thời gian tối đa phải là số nguyên từ 1 đến ${STAY_TIME_MAX_SECONDS} giây`;
  }
  /*
  max <= min thì khách vừa được giữ chỗ đã tới hạn phải rời tập — cấu hình tự mâu thuẫn.
  Chỉ so khi cả hai ô đều đúng định dạng, tránh chồng hai thông báo lên cùng một ô.
  */
  if (!errors.minStayTime && !errors.maxStayTime && max !== null) {
    if (max <= (min ?? DEFAULT_MIN_STAY_TIME)) {
      errors.maxStayTime = 'Thời gian tối đa phải lớn hơn thời gian tối thiểu';
    }
  }
  return errors;
}

/*
Diễn giải số giây sang đơn vị dễ đọc để người nhập tự kiểm tra lại con số vừa gõ
(3600 -> "1 giờ"). Trả về chuỗi rỗng khi không có gì để diễn giải.
*/
export function describeStayTime(value) {
  const seconds = toStayTimeNumber(value);
  if (seconds === null || !Number.isInteger(seconds) || seconds < 60) {
    return '';
  }
  const units = [
    { label: 'ngày', seconds: 86400 },
    { label: 'giờ', seconds: 3600 },
    { label: 'phút', seconds: 60 },
  ];
  let remain = seconds;
  const parts = [];
  units.forEach((unit) => {
    const quantity = Math.floor(remain / unit.seconds);
    if (quantity > 0) {
      parts.push(`${quantity} ${unit.label}`);
      remain -= quantity * unit.seconds;
    }
  });
  if (remain > 0) {
    parts.push(`${remain} giây`);
  }
  return `≈ ${parts.join(' ')}`;
}
